import React, { useEffect, useState, useCallback } from 'react';
import { useMount } from 'react-use';
import {
  Spin,
  Input,
  Avatar,
  Icon,
  AutoComplete,
  message,
  Tooltip,
} from 'antd';
import styles from './selectOwner.module.scss';
import debounce from 'lodash/debounce';
import * as apis from '@/apis';
import get from 'lodash/get';

function renderOption(item, idx) {
  return (
    <AutoComplete.Option key={item._id}>
      <Avatar
        shape="square"
        size={24}
        src={item.avatar || item?.user?.avatar}
      />
      <span> {item.name || item.realname}</span>
    </AutoComplete.Option>
  );
}

function renderEmpty() {
  const emptyInfo = (
    <AutoComplete.Option key="disabled" disabled>
      <span>无匹配项</span>
    </AutoComplete.Option>
  );
  return [emptyInfo];
}

export default function SelecOwner({
  type,
  userType,
  onChange,
  placeholder,
  value: initialValue = null,
  selectKey = '_id',
  ...props
}) {
  const [fetching, setFetching] = useState(false);
  const [user, setUser] = useState();
  const [list, setList] = useState([]);
  const isPlainUser = !['worker', 'manager'].includes(type);
  const handleSearch = useCallback(
    debounce(async (value) => {
      setFetching(true);

      const searchApi =
        {
          worker: apis.searchWorker,
          manager: apis.findManager,
        }[type] || apis.searchUser;

      try {
        const result = await searchApi({
          keyword: value,
          userType,
          limit: 10,
        });
        setFetching(false);
        setList(result.data);
      } catch (err) {
        setFetching(false);
        console.log(err);
        message.error(err.messsage || err || '请求异常');
      }
    }, 800),
    []
  );
  const resetValue = useCallback(() => {
    setUser(null);
    onChange && onChange(null);
  }, []);
  const onSelect = useCallback(
    (value) => {
      const user = list.find((item) => item._id === value);
      setUser(user);
      onChange && onChange(get(user, selectKey));
    },
    [list]
  );
  const init = useCallback(() => {
    if (initialValue && !user) {
      (async () => {
        try {
          if (type === 'worker') {
            const data = await apis.getWorkerById(initialValue);
            setUser(data);
          } else {
            const data = await apis.getMemberById(initialValue);
            setUser(data);
          }
        } catch (err) {}
      })();
    }
  }, [initialValue, user]);

  useEffect(() => {
    init();
  }, []);

  if (user) {
    return (
      <Input
        addonBefore={
          <Avatar
            size={24}
            className={styles.avatar}
            src={user?.user?.avatar || user.avatar}
          ></Avatar>
        }
        addonAfter={
          <Tooltip title="解除">
            <Icon type="close-circle" onClick={resetValue} />
          </Tooltip>
        }
        disabled
        value={isPlainUser ? user.name : user.realname || user.name}
        style={props.style || {}}
      />
    );
  }

  return (
    <div style={props.style || {}}>
      <AutoComplete
        dataSource={list.length ? list.map(renderOption) : renderEmpty()}
        onSearch={handleSearch}
        onSelect={onSelect}
      >
        <Input.Search placeholder={placeholder} loading={fetching} />
      </AutoComplete>
    </div>
  );
}
